import React from 'react'
import NavigationLayout from 'layouts/Navigation'
import Layout from './layouts'

const Browse = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <NavigationLayout>
      <Layout />
    </NavigationLayout>
  )
}

export default Browse